/*!jslint
  this
*/
jQuery(function ($) {
  "use strict";
  function appHeight() {
    var wh = $(window).innerHeight();
    document.documentElement.style.setProperty("--app-height", wh + "px");
  }
  window.addEventListener("resize", appHeight);
  appHeight();

  $(document).on("click", ".main-nav-toggle", function (e) {
    e.preventDefault();
    //$(this).toggleClass('on');
    $("body").toggleClass("nav-open");
    $(".mobile-navigation").removeClass("sub-nav-on");
  });
  $(document).on("click", ".cs-nav-sub-toggle a", function (e) {
    e.preventDefault();
    //$(this).toggleClass('on');
    $(".mobile-navigation").addClass("sub-nav-on");
  });
  $(document).on("click", ".sub-nav-toggle", function (e) {
    //$(this).toggleClass('on');
    $(".mobile-navigation").removeClass("sub-nav-on");
  });
  $(document).on("click", ".contact-form-popup", function (e) {
    e.preventDefault();
    $("body").addClass("cf-open");
  });
  $(document).on("click", ".cf-close", function (e) {
    e.preventDefault();
    $("body").removeClass("cf-open");
  });

  $(".main-navigation ul.menu > li.fw-sub-nav")
    .mouseenter(function () {
      $("body").addClass("sub-nav-on");
    })
    .mouseleave(function () {
      $("body").removeClass("sub-nav-on");
    });

  if ($(window).width() <= 1023) {
    $(document).on("click", ".site-footer-widget h2", function (e) {
      $(this).toggleClass("on");
      $(this).next().find(".menu").slideToggle();
    });
  }
  $(".video-popup").magnificPopup({
    type: "iframe",
    iframe: {
      markup:
        '<div class="mfp-iframe-scaler">' +
        '<div class="mfp-close"></div>' +
        '<iframe class="mfp-iframe" frameborder="0" allowfullscreen></iframe>' +
        "</div>",
      patterns: {
        youtube: {
          index: "youtube.com/",
          id: "v=",
          src: "//www.youtube.com/embed/%id%?autoplay=1",
        },
      },
      srcAction: "iframe_src",
    },
    callbacks: {
      open: function (el) {
        $("html").addClass("mfp-cs-open");
      },
    },
  });
  var isScrolled = false;
  $(window).on("scroll", function () {
    var ST = $(this).scrollTop();
    /*  var $btn = $('.banner');
          if($($btn).length){
          
          var OT = $('.banner').offset().top + $('.banner').outerHeight();
        
            if(ST >= OT){
                $('.main-navigation-2 ul.menu > li:last-child').addClass('loaded');
            }else{
                $('.main-navigation-2 ul.menu > li:last-child').removeClass('loaded');
            }
        }*/
    if (ST >= 10) {
      $(".site-header").addClass("floating");
    } else {
      $(".site-header").removeClass("floating");
    }
  });
  $(function () {
    AOS.init({
      easing: "ease-in-out-sine",
      duration: 400,
      once: true,
    });
  });

  $(".path-anim").each(function (i) {
    var $svg = $(this).drawsvg();
    var $parent = $(this).data("aos-parent");
    var aosid = $("." + $parent).data("aos-id");
    document.addEventListener("aos:in:" + aosid, ({ detail }) => {
      setTimeout(function () {
        $svg.drawsvg("animate");
      }, 300);
    });
  });

  $(document).on("click", ".carousel-prev", function (e) {
    $(this).parents(".carousel-main").find(".slick-slider").slick("slickPrev");
    $(this)
      .parents(".carousel-footer")
      .find(".carousel-footer-bar")
      .removeClass("active");
    $(this)
      .parents(".carousel-footer")
      .find(".carousel-footer-bar")
      .addClass("active");
    setTimeout(() => {
      $(this)
        .parents(".carousel-footer")
        .find(".carousel-footer-bar")
        .removeClass("active");
    }, 1000);
  });

  $(document).on("click", ".carousel-next", function (e) {
    $(this).parents(".carousel-main").find(".slick-slider").slick("slickNext");
    setTimeout(() => {
      $(this)
        .parents(".carousel-footer")
        .find(".carousel-footer-bar")
        .removeClass("active");
    }, 1000);
    $(this).parents(".carousel-main").find(".slick-slider").slick("slickPrev");
    $(this)
      .parents(".carousel-footer")
      .find(".carousel-footer-bar")
      .removeClass("active");
    $(this)
      .parents(".carousel-footer")
      .find(".carousel-footer-bar")
      .addClass("active");
  });

  $(".single-cl").slick({
    dots: false,
    infinite: true,
    arrows: false,
  });

  $(".blog-categories-list").slick({
    dots: false,
    autoplay: false,
    arrows: true,
    slidesToScroll: 1,
    slidesToShow: 1,
    variableWidth: true,
    infinite: false,
    nextArrow:
      "<button type='button' class='slick-next slick-arrow'><svg width='22' height='22' viewBox='0 0 22 22' xmlns='http://www.w3.org/2000/svg' version='1.1' preserveAspectRatio='xMinYMin'><path xmlns='http://www.w3.org/2000/svg' fill='white' d='M6.875 4.95859L7.76445 4.125L15.125 11L7.76445 17.875L6.875 17.0457L13.3418 11L6.875 4.95859Z'/></svg></button>",
    prevArrow:
      "<button type='button' class='slick-prev slick-arrow'><svg width='22' height='22' viewBox='0 0 22 22' xmlns='http://www.w3.org/2000/svg' version='1.1' preserveAspectRatio='xMinYMin'><path xmlns='http://www.w3.org/2000/svg' fill='white' d='M15.125 17.0414L14.2355 17.875L6.875 11L14.2355 4.125L15.125 4.9543L8.6582 11L15.125 17.0414Z'/></svg></button>",
    responsive: [
      {
        breakpoint: 1200,
        settings: {
          infinite: true,
        },
      },
    ],
  });

  $(".related-blogs-cl").slick({
    dots: false,
    autoplay: false,
    arrows: false,
    slidesToScroll: 1,
    slidesToShow: 3,
    infinite: true,
    responsive: [
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 650,
        settings: {
          slidesToShow: 1,
        },
      },
    ],
  });
  function SlickArrowDis() {
    var childrenWidth = 0;
    $(".blog-categories-list .slick-track")
      .children()
      .each(function () {
        childrenWidth += $(this).outerWidth();
      });
    var outerContainerWidth = $(".blog-categories-list").width() + 70;
    var nextArrow = $(".slick-next");
    if (childrenWidth < outerContainerWidth) {
      if (!nextArrow.hasClass("slick-disabled")) {
        nextArrow.addClass("slick-disabled");
      }
    } else {
      if (nextArrow.hasClass("slick-disabled")) {
        nextArrow.removeClass("slick-disabled");
      }
    }
  }
  SlickArrowDis();
  $(window).on("resize", function () {
    SlickArrowDis();
  });

  $(document).on("click", ".copy-clip", function (e) {
    e.preventDefault();
    var value = $(this).data("text");
    var $temp = $("<input>");
    $("body").append($temp);
    $temp.val(value).select();
    document.execCommand("copy");
    $temp.remove();
  });
  $(document).on("change", '.cs-file input[type="file"]', function (e) {
    var fileName = e.target.files[0].name;
    $(this)
      .parent()
      .append('<span class="cs-file-selected-val">' + fileName + "</span>");
    $(this).parents(".cs-file").addClass("file-selected");
  });
  $(document).on("click", ".acc-item-head", function (e) {
    $(".acc-item-head").removeClass("on");
    $(".acc-item-content").slideUp("normal");
    if ($(this).next().is(":hidden") == true) {
      $(this).addClass("on");
      $(this).next().slideDown("normal");
    }
  });

  $(document).on("click", ".loadmore", function (e) {
    e.preventDefault();
    var $el = $(this),
      $tgt = $el.data("target"),
      link = $el.attr("href");
    if ($el.attr("disabled")) return;
    $el.addClass("loading").attr("disabled", true);
    $el.find("span").html("Loading...");
    $("<div>").load(link + $tgt, function () {
      $($tgt).append($(this).find($tgt).html());
      $el.parents(".load-more").removeAttr("disabled").remove();
    });
  });
  $(document).on("click", ".blog-categories a", function (e) {
    e.preventDefault();
    var $el = $(this),
      $tgt = "#loadmorecontainer",
      link = $el.attr("href");
    if ($el.attr("disabled")) return;
    $(".blog-categories a").removeClass("active");
    $el.addClass("active");
    $("body").addClass("blog-loading");
    $($tgt).load(link + " " + $tgt, function () {
      $("body").removeClass("blog-loading");
    });
  });
  $("a.scroll-to").bind("click", function (event) {
    var $anchor = $(this);
    $("html, body")
      .stop()
      .animate(
        {
          scrollTop: $($anchor.attr("href")).offset().top,
        },
        700
      );
    event.preventDefault();
  });

  $(".faq-item-title").click(function () {
    $(".faq-item-title").removeClass("on");
    $(".faq-item-content").slideUp("normal");
    if ($(this).next().is(":hidden") == true) {
      $(this).addClass("on");
      $(this).next().slideDown("normal");
    }
  });
  $(".accordion-section .accordion").click(function () {
    $(".accordion-section .accordion").removeClass("on");
    $(".accordion-section .panel").slideUp("normal");
    if ($(this).next().is(":hidden") == true) {
      $(this).addClass("on");
      $(this).parent().find(".panel").slideDown("normal");
    }
  });

  // Cache selectors
  var lastId,
    topMenu = $(".lwptoc_itemWrap"),
    topMenuHeight = $(".site-header").outerHeight() + 15,
    // All list items
    menuItems = topMenu.find("a"),
    // Anchors corresponding to menu items
    scrollItems = menuItems.map(function () {
      var item = $($(this).attr("href"));
      if (item.length) {
        return item;
      }
    });

  // Bind click handler to menu items
  // so we can get a fancy scroll animation
  menuItems.click(function (e) {
    var href = $(this).attr("href"),
      offsetTop = href === "#" ? 0 : $(href).offset().top - topMenuHeight + 1;
    $("html, body").stop().animate(
      {
        scrollTop: offsetTop,
      },
      300
    );
    e.preventDefault();
  });

  // Bind to scroll
  $(window).scroll(function () {
    // Get container scroll position
    var fromTop = $(this).scrollTop() + topMenuHeight;

    // Get id of current scroll item
    var cur = scrollItems.map(function () {
      if ($(this).offset().top < fromTop) return this;
    });
    // Get the id of the current element
    cur = cur[cur.length - 1];
    var id = cur && cur.length ? cur[0].id : "";

    if (lastId !== id) {
      lastId = id;
      // Set/remove active class
      menuItems
        .parent()
        .removeClass("active")
        .end()
        .filter("[href='#" + id + "']")
        .parent()
        .addClass("active");
    }
  });

  // Maximum value for the progressbar
  var winHeight = $(window).height(),
    docHeight = $(".blog-post-content-main").outerHeight(),
    bHeight = $(".blog-post-header-in").height();
  var max = docHeight - winHeight;
  $(".reading-pgbar").attr("max", max);

  // Inital value (if the page is loaded within an anchor)
  if ($(window).scrollTop() > bHeight) {
    var value = $(window).scrollTop() - bHeight;
  } else {
    var value = 0;
  }
  $(".reading-pgbar").attr("value", value);
  // Maths & live update of progressbar value
  $(document).on("scroll", function () {
    if ($(window).scrollTop() > bHeight) {
      var value = $(window).scrollTop() - bHeight;
    } else {
      var value = 0;
    }
    $(".reading-pgbar").attr("value", value);
    if ($(window).scrollTop() > bHeight) {
      $(".back-to-top").addClass("active");
    } else {
      $(".back-to-top").removeClass("active");
    }
  });
  $(".back-to-top").click(function () {
    $("html, body").animate({ scrollTop: 0 }, 1000);
  });
  /*ga(function(tracker) {
      var clientfield = document.querySelector('[name="input_1001"]'); 
      clientfield.value=tracker.get('clientId');
      
    var referfield = document.querySelector('[name="input_1004"]'); 
      referfield.value=tracker.get('referrer');
    });*/

  $(window)
    .on("resize", function () {
      var winHeight = $(window).height();
      var ctaHeight = $(".sidebar-widget-cta-2").outerHeight();
      var btboxHeight = $(".bottom-box").outerHeight();
      if (ctaHeight == null) {
        ctaHeight = -20;
      }
      if ($(".bottom-box").hasClass("active")) {
        var tocHeight = winHeight - ctaHeight - btboxHeight - 245;
      } else {
        var tocHeight = winHeight - ctaHeight - 245;
      }
      if (tocHeight < 0) {
        tocHeight = 100;
      }
      $(".lwptoc_itemWrap").css("max-height", tocHeight);
    })
    .resize();
  $(document).on("click", ".close-box", function (e) {
    e.preventDefault();
    $(this).parents(".bottom-box").hide().removeClass("active");
    var winHeight = $(window).height();
    var ctaHeight = $(".sidebar-widget-cta-2").outerHeight();
    if (ctaHeight == null) {
      ctaHeight = -20;
    }
    var tocHeight = winHeight - ctaHeight - 245;
    if (tocHeight < 0) {
      tocHeight = 100;
    }
    $(".lwptoc_itemWrap").css("max-height", tocHeight);
  });
});
